
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import Results from '../pages/results/page';

const Home = lazy(() => import('../pages/home/page'));
const Game = lazy(() => import('../pages/game/page'));
const Vote = lazy(() => import('../pages/vote/page'));
const Ranking = lazy(() => import('../pages/ranking/page'));
const Leagues = lazy(() => import('../pages/leagues/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const Tutorial = lazy(() => import('../pages/tutorial/page'));
const Login = lazy(() => import('../pages/login/page'));
const Gems = lazy(() => import('../pages/gems/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/game',
    element: <Game />,
  },
  {
    path: '/vote',
    element: <Vote />,
  },
  {
    path: '/ranking',
    element: <Ranking />,
  },
  {
    path: '/leagues',
    element: <Leagues />,
  },
  {
    path: '/profile',
    element: <Profile />,
  },
  {
    path: '/tutorial',
    element: <Tutorial />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/gems',
    element: <Gems />,
  },
  {
    path: '/results',
    element: <Results />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
